import moment from "moment";
import { GetPrefixUniversity } from "../MainApp";
import Properties from "../components/Properties";
import { toast } from "react-toastify";

export function replaceImageWidth(props, paragraph){
    var regex = "width:[ ]*[0-9]*%";
    var found = paragraph.match(regex);
    if(found === null || found.length <= 0){
      console.log("May be not an image");
      return paragraph;
    }
    console.log("Original image size",found[0]);

    var finalStr = "" + found[0];


    var regex1 = "[0-9]*%";
    var final= finalStr.match(regex1);
    // console.log("final", final);
    if(final.length <= 0){
      console.log("May be not an image");
      return paragraph;
    }
    var number = parseInt(final[0].substring(0, final[0].length - 1));
    console.log("Calculated width of image: ", number);
    var setWidth = "" + number + "%";

    if(!props.isMobile && number <= 30){
      // number = number * 2;
      setWidth = "100%"; // updated from 44% to 100% for new UI
      console.log("Setting width to 44% since width is <= 30: ");

    }else if(props.isMobile && number <= 50){
      console.log("This is a mobile device")
      setWidth = "100%";
      console.log("Setting width to 100% since width is <= 50: ");
    }else{
      //Sclaing to match the image size in the question creation page
      number = number*1.46;
      setWidth = "" + number + "%";
    }

    var newpara = paragraph.replace(new RegExp(regex), "width:"+setWidth);
    //console.log(newpara);
    return newpara;

// expected output: Array ["T", "I"]

}

//Vector Answer Query Evaluate Options
export const EvaluateOptions = [
  {
    label: "=",
    value: 0,
  },
  {
    label: ">",
    value: 1,
  },
  {
    label: "<",
    value: 2,
  },
  {
    label: ">=",
    value: 3,
  },
  {
    label: "<=",
    value: 4,
  }
];
//Vector Answer Query Builder Options
export const QueryOptions = [
  {
    label: "AND",
    value: 0,
  },
  {
    label: "OR",
    value: 1,
  }
];

export function createVideoLinkIframe(htmlString){
  // Since we are not santizing the iframe, we dont need this so we are returning null
  return null;
	const _html = htmlString.trim();
	if(_html){
		const regexResult = _html.match(/<iframe ?.* src="([^"]+)" ?.*>/);
		if(regexResult){
		  let srcPath = regexResult[1];
      const url = new URL(srcPath);

      // add required query parameters to remove yt recommendations if they are missing
      if (!url.searchParams.has('rel')) {
        url.searchParams.set('rel', '0');
      }
      if (!url.searchParams.has('showinfo')) {
        url.searchParams.set('showinfo', '0');
      }
      
      srcPath = url.toString()
		  return <iframe src={`${srcPath.trim().replace(/['"]+/g, '')}`} width={"100%"} height={315} title="video-question" frameborder="0" allow="fullscreen" />
		}
		return null;
	}else{
		return null;
	}
}

export const AppSetting = () => {
	const universityPrefix = GetPrefixUniversity();
	const AppSetting = JSON.parse(window.localStorage.getItem(`${universityPrefix}_StudentAppsettings`));
	return AppSetting
}

export const AppProperties = () => {
	const appProperties = new Properties() ;
	return appProperties;
}
  
export function GetAPPURL() {
	let AppURL = window.location.protocol + "//" + window.location.hostname;
	let PORT = 8095;
	let defaultGOPathName = "/goapi";
  let hostName;
	if (window.location.hostname === 'localhost') {
		AppURL = window.location.protocol + "//" + window.location.hostname + ":" + PORT;
	} else {
    if (window.location.hostname.includes("essentialskills")) {
      hostName = "essentialskills.osu.edu/lti"
    } else if (window.location.hostname.includes("phy-essential-p.asc.ohio-state.edu")) {
      hostName = "phy-essential-p.asc.ohio-state.edu/lti"
    } else if (window.location.hostname.includes("phy-essential-s.asc.ohio-state.edu")) {
      hostName = "phy-essential-s.asc.ohio-state.edu/lti"
    } else {
      let hostArray = window.location.hostname.split(".");
      
      if (hostArray.length > 4) {
        hostName = `${hostArray[hostArray.length - 3]}.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/${hostArray[hostArray.length - 5]}`;
      } else if (hostArray.length == 4) {
        hostName = `${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/${hostArray[hostArray.length - 4]}`;
      }
    }
      AppURL = window.location.protocol + "//" + hostName + defaultGOPathName;
    }
		
	return AppURL;
}

const timeZoneToLocale = {
  // Eastern Time
  "America/New_York": "en-US",    // Eastern Standard Time (EST)
  "America/Detroit": "en-US",      // Eastern Standard Time (EST)
  "America/Toronto": "en-CA",      // Eastern Standard Time (EST) - Canada
  "America/Indiana/Indianapolis": "en-US", // Eastern Standard Time (EST) - Indiana

  // Central Time
  "America/Chicago": "en-US",      // Central Standard Time (CST)
  "America/Winnipeg": "en-CA",     // Central Standard Time (CST) - Canada
  "America/Mexico_City": "es-MX",  // Central Standard Time (CST) - Mexico

  // Mountain Time
  "America/Denver": "en-US",       // Mountain Standard Time (MST)
  "America/Phoenix": "en-US",      // Mountain Standard Time (MST) - Arizona (no DST)

  // Pacific Time
  "America/Los_Angeles": "en-US",  // Pacific Standard Time (PST)
  "America/Vancouver": "en-CA",    // Pacific Standard Time (PST) - Canada

  // Indian Standard Time
  "Asia/Kolkata": "en-IN",         // Indian Standard Time (IST)

};


export function isInvalid(input) {
  return input === null || input === undefined || input === "";
}


export const getDateFormat = (dateStr, timeZone) => {
  if (!dateStr || !timeZone) {
    console.warn("Date or Timezone is invalid", dateStr, timeZone);
    return "";
  }

  let date = moment.tz(dateStr, "DD/MM/YYYY", timeZone);

  let dateInTimeZone = date.toDate();

  let locale = timeZoneToLocale[timeZone] || 'default';

  let formattedDate = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: timeZone
  }).format(dateInTimeZone);

  return formattedDate;
}

export const Logout = () => {
  let appProperties = AppProperties();
  let appSetting = AppSetting();
  console.debug("appProperties.enableLogin", appProperties.enableLogin)
  if (appProperties.enableLogin) {
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'token', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'GivenName', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'USER_NAME', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'UnixEpoch', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'emailid', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'OSUID', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'role', '');
      window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'anonymous', '');
      window.localStorage.setItem('isLTIStudent', '');
      window.localStorage.setItem('practiceCourseID', '');
      window.localStorage.setItem('anonymous_assignment_url', '');
      // window.localStorage.clear();
  }
}
export function hasValidValue(value) {
	if (value === null || value === undefined) return false;
	if (typeof value === 'string' && value.trim() === '') return false;
	if (Array.isArray(value) && value.length === 0) return false;
	if (typeof value === 'object' && Object.keys(value).length === 0) return false;
	return true;
};

export const handleLoginToken = (token) => {
  
  const appProperties = new Properties() ;

  const [encodedHeader, encodedPayload, signature] = token.split('.');
  let decodedPayload;
  try {
    decodedPayload = JSON.parse(atob(encodedPayload));
  } catch (error) {
    console.error("Unable to decode the token", token, error)
    toast.error(`Unable to decode the token`)
    return;
  }

  if (decodedPayload) {
    // Logout the existing user and then setUserDetails
    Logout();
    window.localStorage.setItem("isLTIStudent", decodedPayload.isLTIStudent);
    appProperties.currentUserData.setUserDetails(decodedPayload, appProperties.loginType);
  }

  const queryParams = new URLSearchParams(window.location.search);

  // Remove the token once it's been used
  if (queryParams.has('token')) {
    queryParams.delete('token');
    const newSearch = queryParams.toString();
    const newPath = `${window.location.pathname}?${newSearch}`;
    const encodedPath = encodeURI(newPath);
    window.history.replaceState(null, '', encodedPath);
    window.location.reload();
  } else {
    window.location.reload();
  }
}

export const specialCharacterValidation=(str)=>{
  var response = ['/', '\\','*' ,':' ,',' ,'@' ,'&' ,'%' ,'$' ,'#' ,'!'].some(element => str.includes(element));
  return response
}

export const IsPublicSite = () => {
  const universityPrefix = GetPrefixUniversity();
  if (universityPrefix) {
    let cpanelSettingsStr = window.localStorage.getItem(`${universityPrefix}_StudentAppsettings`);
    if (cpanelSettingsStr) {
      let cpanelSettingsJSON = JSON.parse(cpanelSettingsStr)
      return cpanelSettingsJSON["REACT_APP_PUBLIC_SITE"] ? cpanelSettingsJSON["REACT_APP_PUBLIC_SITE"] : false
    }
    return false;
  }
  return false;
}